//import { combineReducers, createStore, configureStore } from "@reduxjs/toolkit";
//import persistReducer from "redux-persist/es/persistReducer";
//import persistStore from "redux-persist/es/persistStore";
//import  {combineReducers} from 'redux'
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import persistReducer from 'redux-persist/lib/persistReducer';
import storage from './sync_storage';
import dexieStorage from './dexieStorage';
//import storage from 'redux-persist/lib/storage'
import { setupListeners } from '@reduxjs/toolkit/dist/query/react';
import persistStore from 'redux-persist/lib/persistStore';
import pageEditorCanvas from './slices/pageEditorCanvasSlice';
import pageEditorModelData from './slices/pageEditorModelDataSlice';
import flowEditor from './slices/flowEditorSlice';
import resourceEditor from './slices/resourceEditorSlice';
import pageEditor from './slices/pageEditorSlice';
import workSpace from './slices/workspaceSlice';
import commonData from './slices/commonDataSlice';
import authToken from './slices/authTokenSlice';
import widgetApi from './slices/widgetApiSlice';
import chatbotData from './slices/chatbotDataSlice';
const pageEditorConfig = {
  key: 'pageEditor',
  storage: dexieStorage,
 };
const pageEditorCanvasConfig = {
  key: 'pageEditorCanvas',
  storage: dexieStorage,
 };
 const pageEditorModelDataConfig = {
  key: 'pageEditorModelData',
  storage: dexieStorage,
  blacklist: [''],
};
const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['pageEditorCanvas','pageEditorModelData', 'pageEditor'],
};
const resourseEditorConfig = {
  key: 'resourceEditor',
  storage: storage,
  blacklist: [''],
};

const flowEditorConfig = {
  key: 'flowEditor',
  storage: storage,
  blacklist: [''],
};
// const pageEditorConfig = {
//   key: 'pageEditor',
//   storage: storage,
//   blacklist: [''],
// };
// const pageEditorCanvasConfig = {
//   key: 'pageEditorCanvas',
//   storage: storage,
//   blacklist: [''],
// };
// const pageEditorModelDataConfig = {
//   key: 'pageEditorModelData',
//   storage: storage,
//   blacklist: [''],
// };
const commonDataConfig = {
  key: 'commonData',
  storage: storage,
  blacklist: [''],
};
const authTokenConfig = {
  key: 'authToken',
  storage: storage,
  blacklist: [''],
};
const workSpaceConfig = {
  key: 'workSpace',
  storage: storage,
  blacklist: [''],
};
const widgetApiConfig = {
  key: 'widgetApi',
  storage: storage,
  blacklist: [''],
};
const chatbotDataConfig = {
  key: 'chatbotData',
  storage: storage,
  blacklist: [''],
};

const combinedReducer = combineReducers({
  pageEditorCanvas: persistReducer(pageEditorCanvasConfig, pageEditorCanvas),
  pageEditorModelData: persistReducer(pageEditorModelDataConfig, pageEditorModelData),
  resourceEditor: persistReducer(resourseEditorConfig, resourceEditor),
  flowEditor: persistReducer(flowEditorConfig, flowEditor),
  pageEditor: persistReducer(pageEditorConfig, pageEditor),
  workSpace: persistReducer(workSpaceConfig, workSpace),
  widgetApi: persistReducer(widgetApiConfig, widgetApi),
  chatbotData: persistReducer(chatbotDataConfig, chatbotData),

  userData: {},
  message: {},
  commonData: persistReducer(commonDataConfig, commonData),
  authToken: persistReducer(authTokenConfig, authToken),
});

const rootReducer = (state, action) => {
  if (action.type === 'workSpace/reset') {
    state = undefined;
  }
  return combinedReducer(state, action);
};

const initialState = {};
const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  initialState,
  devTools: process.env.NODE_ENV !== 'production',
});
setupListeners(store.dispatch);
export const persistor = persistStore(store, {}, () => {
  persistor.persist();
});
export const RootState = store.getState;
export const AppDispatch = store.dispatch;
export default store;

// import {configureStore} from "@reduxjs/toolkit";
// import profileEditorReducer from "./slices/profileEditorSlice";
// import flowEditorReducer from "./slices/flowEditorSlice";
// import resourceEditorReducer from "./slices/resourceEditorSlice";

// const store = configureStore({
//     reducer: {
//         profileEditor: profileEditorReducer,
//         resourceEditor: resourceEditorReducer,
//         flowEditor:flowEditorReducer,
//         userData: {},
//         message:{}
//     },
//     devTools: process.env.NODE_ENV === "development"
// });

// export const RootState = store.getState;
// export const AppDispatch = store.dispatch;
// export default store;
